import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "./queryKeys";
import {
  getTranslation,
  getTranslations,
} from "~/lib/server-functions/get-translation";

export function useTranslation(
  namespace: string,
  key: string,
  language: number = 0,
) {
  return useQuery<string | null>({
    queryKey: [QUERY_KEYS.TRANSLATION, namespace, key, language],
    queryFn: () =>
      getTranslation({ data: { namespace, key, language } }),
  });
}

export function useTranslations(
  namespace: string,
  keys: string[],
  language: number = 0,
) {
  return useQuery<Record<string, string>>({
    queryKey: [QUERY_KEYS.TRANSLATION, namespace, keys, language],
    queryFn: () =>
      getTranslations({ data: { namespace, keys, language } }),
    enabled: keys.length > 0,
  });
}
